"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var deactivateButtons = document.querySelectorAll('.watchdogs .deactivate-button');
    var wishlistService = abp.services.api.wishlist;
    var moveWdButton = document.getElementById('moveAllActiveWatchdogsToNewProduct');

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = deactivateButtons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var dButton = _step.value;

            dButton.addEventListener('click', function (event) {
                return _message2.default.confirm(Resx.Messages.DoYouReallyWantToDeactivateWatchDog, Resx.Messages.ConfirmTitle, function (isConfirmed) {
                    return deactivateWatchDogCLick(event, isConfirmed);
                });
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    if (moveWdButton) {
        moveWdButton.addEventListener('click', moveWdButtonClick);
    }

    function deactivateWatchDogCLick(event, isConfirmed) {
        if (!isConfirmed) return;

        var clickedButton = event.target;
        var wishListId = clickedButton.dataset.id;
        wishlistService.invalidateWishListItem(wishListId).done(function () {
            _notify2.default.success(Resx.App.WatchDogRemoved);
            var row = clickedButton.closest('tr');
            row.classList.add('inactive');
            row.querySelector('.watchdog-active').textContent = Resx.Common.No;
            clickedButton.parentElement.removeChild(clickedButton);
        }).fail(function (error) {
            _message2.default.error(Resx.Common.Error);
            console.error(error);
        });
    }

    function moveWdButtonClick() {
        var productIdElement = document.getElementById('productId');
        if (!productIdElement) return;

        var currentProductId = productIdElement.value;
        var selectedProductArray = (0, _jquery2.default)('#newProductInput').select2('data');

        if (selectedProductArray.length === 0) {
            _notify2.default.warn(Resx.App.ProductNotSelected || 'Product is not selected');
            return;
        }

        _message2.default.confirm(Resx.Messages.DoYouReallyWantToMoveWatchDogs, Resx.Messages.ConfirmTitle, function (isConfirmed) {
            if (!isConfirmed) return;

            var selectedProductObject = selectedProductArray.pop();
            var selectedProductId = selectedProductObject.id;
            var includeInactive = _common2.default.getElementPropertySafe('#includeInactive', 'checked') || false;
            var includeDeleted = _common2.default.getElementPropertySafe('#includeDeleted', 'checked') || false;

            wishlistService.moveWatchDogsToNewProduct(currentProductId, selectedProductId, includeInactive, includeDeleted).done(function () {
                _notify2.default.success(Resx.Messages.WatchdogsMovedToProduct + " " + selectedProductObject.name);

                var selector = ".watchdog-tab table.watchdogs tr";
                if (!includeInactive) selector += ':not(.inactive)';
                if (!includeDeleted) selector += ':not(.deleted)';

                var rowsToRemove = document.querySelectorAll(selector);
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = rowsToRemove[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var row = _step2.value;

                        row.parentElement.removeChild(row);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }).fail(function (error) {
                _message2.default.error(Resx.Common.Error);
                console.error(error);
            });
        });
    }
};

var _notify = require("linksoft/notify");

var _notify2 = _interopRequireDefault(_notify);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _message = require("linksoft/message");

var _message2 = _interopRequireDefault(_message);

var _common = require("../common");

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/productWishList.js
// module id = 440
// module chunks = 0